import React from "react";
import HomeContainer from "../HomeContainer";

const CoursePlan2 = () => {
  return (
    <HomeContainer>
      <div>
        <h5>Course Plan</h5>
        <p>
          <span style={{ color: "#0a9396", fontWeight: "bold" }}>
            শিশুর কাছ থেকে কম্পিউটার ডিভাইসটি কেড়ে নেয়ার দরকার নেই,
          </span>{" "}
          <span style={{ color: "#005f73" }}>
            বরং বিনোদনের মাধ্যমটি কৌশলে সংশোধন করে দিন। আমাদের
            <span style={{ color: "#0a9396", fontWeight: "bold" }}>
              {" "}
              Ai for Kids
            </span>
            কোর্সটি এমনভাবে ডিজাইন করা যার মাধ্যমে ১২-১৫ বছরের সন্তান নিজে থেকেই
            অনায়েশে সস্তা ভিডিও এবং গেইমের জগত ছেড়ে নিজেকে আধুনিক প্রযুক্তির
            যাদুর কাঠি Ai এর বন্ধু বানিয়ে নিবে। আমাদের শিশুরা সঠিক পথে থাকলে
            জাতি হিসেবে আমাদের ভবিষ্যত উজ্জ্বল। Comming soon...
          </span>
        </p>
        <ul>
          <li>1...</li>
          <li>2...</li>
        </ul>
      </div>
    </HomeContainer>
  );
};

export default CoursePlan2;
